export default __webpack_public_path__ + "static/media/button.dfe6bc43.mp3";